import { EnterAccessCode } from "./enter-access-code.js";
import { SupportContext } from "./provider.js";
import React from "react";
export const SupportGate = ({ body, children, headline }) => {
    const { data } = React.useContext(SupportContext);
    return !!data ? (React.createElement(React.Fragment, null, children)) : (React.createElement(EnterAccessCode, { headline: headline, body: body }));
};
//# sourceMappingURL=gate.js.map